var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsultation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 95,
    viewBox: "0 0 68 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9697 0H2.32971C1.04143 0 0 1.02822 0 2.30017V92.7074C0 93.9794 1.04143 95.0076 2.32971 95.0076H64.9697C66.258 95.0076 67.2994 93.9794 67.2994 92.7074V2.30017C67.2917 1.02822 66.2502 0 64.9697 0Z",
    fill: "url(#paint0_linear_27_0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.858 4.09766H6.43371C5.184 4.09766 4.16571 5.10303 4.16571 6.34451V81.0923C4.16571 82.3338 5.184 83.3316 6.43371 83.3316H60.858C62.1154 83.3316 63.126 82.3262 63.126 81.0923V6.34451C63.126 5.10303 62.1154 4.09766 60.858 4.09766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7737 39.636H22.5257C21.5074 39.636 20.682 38.8211 20.682 37.8157V15.8422C20.682 14.8369 21.5074 14.0219 22.5257 14.0219H44.7737C45.792 14.0219 46.6174 14.8369 46.6174 15.8422V37.8081C46.6174 38.8135 45.792 39.636 44.7737 39.636Z",
    fill: "url(#paint1_linear_27_0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6497 92.5475C35.5413 92.5475 37.0748 91.0335 37.0748 89.1658C37.0748 87.2981 35.5413 85.7841 33.6497 85.7841C31.758 85.7841 30.2245 87.2981 30.2245 89.1658C30.2245 91.0335 31.758 92.5475 33.6497 92.5475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0357 51.015H14.256C13.2763 51.015 12.474 50.2229 12.474 49.2556C12.474 48.2883 13.2763 47.4962 14.256 47.4962H53.028C54.0077 47.4962 54.81 48.2883 54.81 49.2556C54.81 50.2229 54.0154 51.015 53.0357 51.015Z",
    fill: "url(#paint2_linear_27_0)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.4708 60.764H13.608C12.9831 60.764 12.4817 60.2613 12.4817 59.652V59.5302C12.4817 58.9132 12.9909 58.4182 13.608 58.4182H46.4708C47.0957 58.4182 47.5971 58.9208 47.5971 59.5302V59.652C47.6048 60.2613 47.0957 60.764 46.4708 60.764Z",
    fill: "url(#paint3_linear_27_0)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40.2146 66.9562H13.5C12.9369 66.9562 12.474 66.4992 12.474 65.9432V65.6081C12.474 65.0521 12.9369 64.5951 13.5 64.5951H40.2068C40.77 64.5951 41.2328 65.0521 41.2328 65.6081V65.9432C41.2328 66.4992 40.77 66.9562 40.2146 66.9562Z",
    fill: "url(#paint4_linear_27_0)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M43.578 72.6914H13.5617C12.9677 72.6914 12.4817 72.2116 12.4817 71.6251V71.4119C12.4817 70.8254 12.9677 70.3456 13.5617 70.3456H43.578C44.172 70.3456 44.658 70.8254 44.658 71.4119V71.6251C44.658 72.204 44.172 72.6914 43.578 72.6914Z",
    fill: "url(#paint5_linear_27_0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7166 26.1208C35.9441 26.1208 37.7498 24.3141 37.7498 22.0854C37.7498 19.8566 35.9441 18.05 33.7166 18.05C31.489 18.05 29.6833 19.8566 29.6833 22.0854C29.6833 24.3141 31.4805 26.1208 33.7166 26.1208ZM33.7166 28.1385C31.0249 28.1385 25.65 29.4892 25.65 32.1739V33.1869C25.65 33.7441 26.1056 34.2 26.6625 34.2H40.7875C41.3444 34.2 41.8 33.7441 41.8 33.1869V32.1739C41.7831 29.4977 36.4082 28.1385 33.7166 28.1385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_0",
    x1: 4.07698,
    y1: 45.0301,
    x2: 67.3445,
    y2: 50.4539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_0",
    x1: 18.6708,
    y1: 19.2924,
    x2: 48.4654,
    y2: 34.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0856277,
    stopColor: "#A3F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2972,
    stopColor: "#8AE7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    stopColor: "#77E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#6DDDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_0",
    x1: 54.8137,
    y1: 49.257,
    x2: 12.4813,
    y2: 49.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27_0",
    x1: 47.6026,
    y1: 59.5877,
    x2: 12.4813,
    y2: 59.5877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27_0",
    x1: 41.2336,
    y1: 65.7799,
    x2: 12.4813,
    y2: 65.7799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27_0",
    x1: 44.6574,
    y1: 71.5124,
    x2: 12.4813,
    y2: 71.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.2917,
    height: 95,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.0c2ba99ef1b7be24933f953d48352cb2.svg";
export { ForwardRef as ReactComponent };